import { IncomeCollectionExperiment, IncomeCollectionVariantValues } from '@genoa/experiments'

import { useExperimentVariant } from '../../../../hooks'

export function useIncomeCollectionExperiment() {
  const variant = useExperimentVariant(IncomeCollectionExperiment)
  return variant === IncomeCollectionVariantValues.Treatment
}
